import { Antwoord, ValidatieParameter, Vraag } from '@models/claims';
import { VraagboomUploadResultaat, Uploadfile } from '@models/vragenboom';
import { ValidatieregelHelper } from '@services/public_api';

// @dynamic
export class FileValidator {
  static isValidExtensionOfFile(antwoord: Antwoord, file: File): boolean {
    if (file == null) {
      return false;
    }

    return this.isValidExtension(antwoord, file.name);
  }

  static isValidExtensionOfFoto(vraag: Vraag, resultaat: VraagboomUploadResultaat): boolean {
    if (resultaat == null) {
      // No photo's uploaded yet
      return true;
    }

    if (vraag == null || vraag.antwoorden == null) {
      return false;
    }

    if (vraag.antwoorden.length < resultaat.uploadedFiles.length) {
      return false;
    }

    let isValid = true;

    if (resultaat.uploadedFiles != null) {
      for (let index = 0; index < resultaat.uploadedFiles.length; index++) {
        const antwoord: Antwoord = vraag.antwoorden[index];
        const foto: Uploadfile = resultaat.uploadedFiles[index];
        isValid = isValid && this.isValidExtension(antwoord, foto.name);
      }

      return isValid;
    }

    return true;
  }

  public static allowedExtensions(vraag: Vraag): string[] {
    if (vraag == null || vraag.antwoorden == null || vraag.antwoorden.length === 0) {
      return [];
    }

    return this.allowedExtensionsAntwoord(vraag.antwoorden[0]);
  }

  public static allowedExtensionsAntwoord(antwoord: Antwoord): string[] {
    const extensionValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'EXTENSIE');
    if (extensionValidator != null) {
      return extensionValidator.validatie_parameters.split(';');
    }

    return [];
  }

  private static isValidExtension(antwoord: Antwoord, filename: string): boolean {
    if (antwoord == null) {
      return false;
    }

    const extensionValidator = ValidatieregelHelper.get(antwoord.validatieParameters, 'EXTENSIE');
    if (extensionValidator != null) {
      const allowedExtensions = extensionValidator.validatie_parameters.toLowerCase().split(';');

      const extensionIndex = filename.lastIndexOf('.') + 1;
      if (extensionIndex >= filename.length) {
        return false;
      }

      const extension = filename.substring(extensionIndex).toLowerCase();
      if (allowedExtensions.indexOf(extension) < 0) {
        return false;
      }
    }

    return true;
  }

  static isValidNumberOfFiles(vraag: Vraag, resultaat: VraagboomUploadResultaat): boolean {
    if (resultaat == null) {
      // No photo's uploaded yet
      return true;
    }

    if (vraag == null) {
      return false;
    }

    const numberOfFotosValidator: ValidatieParameter = ValidatieregelHelper.get(vraag.validatieParameters, 'MIN_MAX');
    if (numberOfFotosValidator != null) {
      const minMaxValue = numberOfFotosValidator.validatie_parameters.split(';');
      const minFiles: number = Number(minMaxValue[0]);
      const maxFiles: number = Number(minMaxValue[1]);

      if (!isNaN(maxFiles) && (resultaat.uploadedFiles.length > maxFiles || resultaat.uploadedFiles.length < minFiles)) {
        return false;
      }
    }

    return true;
  }

  static isValidNumberOfFilesAntwoord(antwoorden: Antwoord[], resultaat: VraagboomUploadResultaat): boolean {
    if (resultaat == null) {
      // No photo's uploaded yet
      return true;
    }

    if (antwoorden == null) {
      return false;
    }

    let groepId = '';
    let maxNumberValidator: ValidatieParameter;
    let minMaxValue: string[];
    let minFiles = 0;
    let maxFiles = 0;
    let isValidNumber = true;
    let files: Uploadfile[];

    antwoorden.forEach((antw: Antwoord) => {
      if (antw.groep_id !== groepId) {
        minFiles = 0;
        maxFiles = 0;
        maxNumberValidator = ValidatieregelHelper.get(antw.validatieParameters, 'MIN_MAX');
        if (maxNumberValidator != null) {
          minMaxValue = maxNumberValidator.validatie_parameters.split(';');
          minFiles = Number(minMaxValue[0]);
          maxFiles = Number(minMaxValue[1]);
          files = resultaat.uploadedFiles.filter(u => u.groepId === antw.groep_id);

          if (!isNaN(minFiles) && !isNaN(maxFiles) && files && (files.length < minFiles || files.length > maxFiles)) {
            isValidNumber = false;
          }
        }

        groepId = antw.groep_id;
      }
    });

    return isValidNumber;
  }
}
